import { AppState } from "../../../store";

export const topOffenderFilterSelector = (state: AppState) =>
  state.topOffenderFilters;

export const selectedRegionSelector = (state: AppState) =>
  state.topOffenderFilters.selectedRegion;

export const selectedTypeSelector = (state: AppState) =>
  state.topOffenderFilters.selectedType;

export const selectedStatusSelector = (state: AppState) =>
  state.topOffenderFilters.selectedStatus;

export const selectedAlarmTypeSelector = (state: AppState) =>
  state.topOffenderFilters.selectedAlarmType;

export const selectedConfigStatusSelector = (state: AppState) =>
  state.topOffenderFilters.selectedConfigStatus;
